import mapApi from '@/api/map.api'

export const mapService = (function () {
  'use strict'

  async function getCurrentState(enterpriseId) {
    try {
      const response = await mapApi.getCurrentState(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  return {
    getCurrentState
  }
})()
